import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../../ui/layout/theme-next/provider';
import { itemStyles } from '../HelpCenterList/HelpCenterList.styles';

export default makeStyles<NextTheme>((theme) => ({
  ...itemStyles(theme),
  list: {
    flexGrow: 1,
  },
  contact: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    position: 'relative',
  },
  out: {
    '&:before': {
      content: "''",
      position: 'absolute',
      inset: 0,
    },
  },
}));
